import React from 'react';
import { Tabs, Tab } from '@mui/material';
import useInterveneSx from '../../hooks/useInterveneSx';
import {
  CONTEXT_DRAWER_TAB_LIST,
  CONTEXT_DRAWER_TABS,
  getContextDrawerTabId,
  getContextDrawerTabPanelId,
} from '../../constants/contextDrawerTabs';

export default function ContextDrawerTabs({
  activeTab,
  onTabChange,
  showAiTab = false,
}) {
  const styles = useInterveneSx().contextDrawer;

  const visibleTabs = CONTEXT_DRAWER_TAB_LIST.filter(
    (tab) => tab.id !== CONTEXT_DRAWER_TABS.AI || showAiTab
  );

  const handleChange = (_event, value) => {
    onTabChange(value);
  };

  return (
    <Tabs
      value={activeTab}
      onChange={handleChange}
      variant="scrollable"
      scrollButtons="auto"
      aria-label="Customer context tabs"
      sx={styles.tabsRoot}
    >
      {visibleTabs.map((tab) => (
        <Tab
          key={tab.id}
          value={tab.id}
          label={tab.label}
          id={getContextDrawerTabId(tab.id)}
          aria-controls={getContextDrawerTabPanelId(tab.id)}
        />
      ))}
    </Tabs>
  );
}
